import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Trusted by Golfers Everywhere | ShipSticks',
  description:
    "Don't take our word for it - see what real users have to say about their experience " +
    'shipping golf clubs with ShipSticks.',
  alternates: {
    canonical: 'https://www.shipsticks.com/reviews',
  },
}

export default metadata
